// src/workers/altcha-worker.ts

// export const altchaWorkerUrl = new URL('altcha/dist_external/worker.js', import.meta.url).href;

export const altchaWorkerUrl = new URL(
  '../../node_modules/altcha/dist_external/worker.js',
  import.meta.url
).href;
